/**
 * Filter Dealers — Rede de Serviços Supperfrigo
 *
 * Lista todos os dealers no boot. Select UF + input de busca filtram
 * progressivamente. Sem filtro = todos visíveis.
 */
(function ($) {
    'use strict';

    // Remove acentos e caracteres combinantes pra busca ser insensível a acentuação
    function stripAccents(str) {
        return (str || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    $(function () {
        var $page = $('.page-rede-de-servicos-supperfrigo');
        if (!$page.length) return;

        var $uf       = $page.find('[data-dealers-filter="uf"]');
        var $search   = $page.find('[data-dealers-filter="search"]');
        var $reset    = $page.find('[data-dealers-reset]');
        var $list     = $page.find('[data-dealers-list]');
        var $cards    = $page.find('[data-dealer]');
        var $count    = $page.find('[data-dealers-count]');
        var $countVal = $page.find('[data-dealers-count-value]');
        var $plurals  = $page.find('[data-dealers-count-plural]');
        var $noResults = $page.find('[data-dealers-noresults]');

        function applyFilter(scrollAfter) {
            var ufVal = ($uf.val() || '').trim();
            var qVal  = stripAccents(($search.val() || '').trim().toLowerCase());

            var matched = 0;
            $cards.each(function () {
                var $card = $(this);
                var cardUf  = ($card.data('uf') || '').toString();
                var cardTxt = stripAccents(($card.data('search') || '').toString().toLowerCase());

                var matchUf = ufVal === '' || cardUf === ufVal;
                var matchQ  = qVal === ''  || cardTxt.indexOf(qVal) !== -1;

                if (matchUf && matchQ) {
                    $card.removeAttr('hidden');
                    matched++;
                } else {
                    $card.attr('hidden', true);
                }
            });

            if (matched > 0) {
                $list.removeAttr('hidden');
                $count.removeAttr('hidden');
                $noResults.attr('hidden', true);
                $countVal.text(matched);
                $plurals.text(matched === 1 ? '' : 's');
            } else {
                $list.attr('hidden', true);
                $count.attr('hidden', true);
                $noResults.removeAttr('hidden');
            }

            // Scroll até resultados só em mobile (≤ 991px) e apenas ao interagir
            if (scrollAfter && $(window).width() <= 991) {
                var $target = matched > 0 ? $count : $noResults;
                if ($target.length && $target.is(':visible')) {
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 80
                    }, 400);
                }
            }
        }

        var searchScrollTimer = null;

        $uf.on('change', function () { applyFilter(true); });

        $search.on('input', function () {
            // Filtra em tempo real (sem scroll)
            applyFilter(false);
            // Scroll só depois de 600ms sem digitar (evita rolar a cada tecla)
            if (searchScrollTimer) clearTimeout(searchScrollTimer);
            searchScrollTimer = setTimeout(function () {
                applyFilter(true);
            }, 600);
        });

        $reset.on('click', function () {
            if (searchScrollTimer) { clearTimeout(searchScrollTimer); searchScrollTimer = null; }
            $uf.val('');
            $search.val('');
            applyFilter(true);
        });

        applyFilter(false);
    });
})(jQuery);
